import SectionHeader from "@/components/SectionHeader";

/**
 * "So vergleichen wir" — der günstigste Vertrauensgewinn, den es gibt.
 *
 * Bis hierher stand an dieser Stelle eine Kachelreihe mit "Unabhängiger
 * Vergleich", "Transparente Bewertung", "Klare Orientierung" — drei
 * Behauptungen ohne Beleg. Google bewertet an solchen Stellen, ob jemand
 * offenlegt, wie er arbeitet und woran er verdient; Nutzer ebenso.
 *
 * Deshalb steht hier auch, was wir NICHT tun: Wir testen die Boxen nicht
 * selbst. Das offen zu sagen ist glaubwürdiger, als "geprüft" zu schreiben
 * und auf Nachfragen keine Antwort zu haben.
 */

export default function MethodikSektion({ anzahlBoxen, anzahlAnbieter }) {
  const PUNKTE = [
    {
      titel: "Woher die Daten kommen",
      text: `Die Angaben zu ${anzahlBoxen} Fotoboxen von ${anzahlAnbieter} Anbietern pflegen die Anbieter selbst in unserem Backend — Ausstattung, Pakete, Preise, Liefergebiete. Ändert ein Anbieter etwas, steht es innerhalb einer Stunde hier.`,
    },
    {
      titel: "Wie wir bewerten",
      text: "Kamera und Licht bewerten wir nach einer festen Tabelle: Eine Spiegelreflexkamera bekommt dieselbe Note, egal von welchem Anbieter sie kommt. Preise rechnen wir immer als Grundpreis plus Paket, damit sie vergleichbar sind — bei regionalen Anbietern zusätzlich die Anfahrt für deine Postleitzahl.",
    },
    {
      titel: "Was wir nicht tun",
      text: "Wir testen die Fotoboxen nicht selbst und schreiben keine eigenen Testberichte. Was hier steht, sind nachprüfbare Angaben und Berechnungen daraus — keine Erfahrungsberichte.",
    },
    {
      titel: "Womit wir Geld verdienen",
      text: "Über Provisionen: bei einigen Anbietern für eine vermittelte Buchung, bei anderen für die Weiterleitung. Werbeplätze sind als Anzeige gekennzeichnet. Auf die Bewertung von Kamera, Licht und Druck hat das keinen Einfluss — die Kriterien sind für alle dieselben.",
    },
  ];

  return (
    <SectionHeader
      id="methodik"
      title="So vergleichen wir"
      subtitle="Woher die Daten kommen, wie wir rechnen — und woran wir verdienen."
    >
      <div className="mx-auto mt-8 grid max-w-4xl gap-4 text-left sm:grid-cols-2">
        {PUNKTE.map((p) => (
          <div
            key={p.titel}
            className="rounded-2xl bg-slate-50 p-5 ring-1 ring-slate-200/70"
          >
            <h3 className="text-base font-semibold text-slate-900">
              {p.titel}
            </h3>
            <p className="mt-2 text-sm leading-6 text-slate-600">{p.text}</p>
          </div>
        ))}
      </div>
    </SectionHeader>
  );
}
